import React from 'react';

import { useFormContext } from 'react-hook-form';

import { useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/UpdateReportTags/UpdateReportTags.module.scss';
import {
    isNewTagNamedFavorites,
    optionsToTags,
} from 'components/Dashboards/Reporting/ReportSettingsModal/components/UpdateReportTags/UpdateReportTags.utils';
import { ReportTagsSelectWithCreate } from 'components/Dashboards/Reporting/_common/ReportTagsSelectWithCreate/ReportTagsSelectWithCreate';
import { FAVORITES } from 'components/Dashboards/Reporting/reporting.consts';

export const UpdateReportTags = () => {
    const { control, setValue } = useFormContext<FormValues>();
    const { handleSnackBar } = useCustomSnackBar();

    const handleChange = (value: ISelectOption<number>[]) => {
        if (value.some(isNewTagNamedFavorites)) {
            handleSnackBar(`You cannot create a tag named '${FAVORITES}'.`, 'error');
            return;
        }
        const selectedTags = optionsToTags(value);
        setValue('selectedTags', selectedTags, { shouldDirty: true });
    };

    return (
        <div className={classes.tags}>
            <label>Tags: </label>
            <div className={classes.tagsSelect}>
                <ReportTagsSelectWithCreate control={control} handleChange={handleChange} />
            </div>
        </div>
    );
};
